import { configureStore } from "@reduxjs/toolkit";
import authReducer, { loadStateFromLocalStorage } from "./auth/authSlice";
import cartSlice from "./cartSlice";
import productSlice from "./productSlice";



const store = configureStore({
  reducer: {
    auth: authReducer,
    product: productSlice,
    cart:cartSlice,
  },
  preloadedState: {
    auth: loadStateFromLocalStorage(),

  },
});

export default store;
